import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@mui/material';
import useDialogSubmit from 'shared/hooks/useDialogSubmit';
import { STORES } from 'pages/GoogleWatchdog/types';

export default function LogChangeDialog({ open, onClose, onLog }: {
  open: boolean; onClose: () => void;
  onLog: (body: { summary: string; store?: string; rationale?: string; oldValue?: string; newValue?: string; changedAt?: string }) => Promise<void>;
}) {
  const [summary, setSummary] = useState('');
  const [store, setStore] = useState('');
  const [rationale, setRationale] = useState('');
  const [oldValue, setOldValue] = useState('');
  const [newValue, setNewValue] = useState('');
  const [changedAt, setChangedAt] = useState('');
  const { busy, error, submit } = useDialogSubmit(onClose);
  const logIt = () => submit(() => onLog({
    summary: summary.trim(), store: store || undefined, rationale: rationale || undefined,
    oldValue: oldValue || undefined, newValue: newValue || undefined, changedAt: changedAt || undefined,
  }));
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Log a change</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '8px !important' }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField autoFocus multiline minRows={2} label="What changed?" value={summary} onChange={e => setSummary(e.target.value)} />
        <TextField select label="Store" value={store} onChange={e => setStore(e.target.value)}>
          <MenuItem value="">—</MenuItem>
          {STORES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
        </TextField>
        <TextField label="Why? (rationale)" multiline value={rationale} onChange={e => setRationale(e.target.value)} />
        <TextField label="Old value (optional)" value={oldValue} onChange={e => setOldValue(e.target.value)} />
        <TextField label="New value (optional)" value={newValue} onChange={e => setNewValue(e.target.value)} />
        <TextField type="date" label="When (defaults to today)" InputLabelProps={{ shrink: true }} value={changedAt} onChange={e => setChangedAt(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!summary.trim() || busy} onClick={logIt}>Log it</Button>
      </DialogActions>
    </Dialog>
  );
}
